import { render, staticRenderFns } from "./EditBranchContent.vue?vue&type=template&id=43220daa&scoped=true"
import script from "./EditBranchContent.vue?vue&type=script&lang=js"
export * from "./EditBranchContent.vue?vue&type=script&lang=js"
import style0 from "./EditBranchContent.vue?vue&type=style&index=0&id=43220daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43220daa",
  null
  
)

export default component.exports